export class UpdateAvatarRequest {
  avatarColor: string;

  constructor(avatarColor: string) {
    this.avatarColor = avatarColor;
  }
}
